'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');

var address1Required = function (input) {
    if (input.address1.length < 4) {
        return { error: true, messageFragment: 'Address 1: Please provide an address.' };
    }
    return { error: false };
};
var cityRequired = function (input) {
    if (input.city.length === 0) {
        return { error: true, messageFragment: 'City: Please provide a city.' };
    }
    return { error: false };
};
var stateRequired = function (input) {
    if (input.state === 'default' || input.state.length === 0) {
        return { error: true, messageFragment: 'State: Please select a State or Province' };
    }
    return { error: false };
};
var zipCodeRequired = function (input) {
    if (input.zipCode.length === 5 || input.zipCode.length === 10 || input.zipCode.length === 7) {
        return { error: false };
    }
    return {
        error: true,
        messageFragment: 'Zip Code: Please enter a 5 or 9 digit postal code.',
    };
};
// from https://howtodoinjava.com/regex/canada-postal-code-validation/
var CA_ZIP_REGEX = new RegExp('^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$');
var zipCodeNumeric = function (input) {
    if (input.zipCode.length === 5) {
        if (parseInt(input.zipCode, 10) > 9999) {
            return { error: false };
        }
        return {
            error: true,
            messageFragment: 'Zip Code: Please enter a 5 digit zip code',
        };
    }
    if (input.zipCode.length === 10) {
        if (parseInt(input.zipCode.substring(0, 5), 10) > 9999 &&
            parseInt(input.zipCode.substring(7, 10), 10) < 10000) {
            return { error: false };
        }
        return {
            error: true,
            messageFragment: 'Zip Code: Please enter a 10 digit zip code XXXXX-XXXX',
        };
    }
    if (input.zipCode.length === 7) {
        if (!CA_ZIP_REGEX.test(input.zipCode)) {
            return {
                error: true,
                messageFragment: 'Zip Code: Please enter a valid zip or postal code',
            };
        }
    }
    return { error: false };
};
var requiredValidators = [address1Required, cityRequired, stateRequired, zipCodeRequired];
var notRequiredValidators = [zipCodeNumeric];
var validators = tslib.__spreadArrays(requiredValidators, notRequiredValidators);

exports.address1Required = address1Required;
exports.cityRequired = cityRequired;
exports.default = validators;
exports.notRequiredValidators = notRequiredValidators;
exports.requiredValidators = requiredValidators;
exports.stateRequired = stateRequired;
exports.zipCodeNumeric = zipCodeNumeric;
exports.zipCodeRequired = zipCodeRequired;
